import React, { useContext, useMemo, useState } from 'react'
import './taskbar.css'
import AppObj from 'model/appConfigObj';
import { desktopAppTaskContex } from '.';
import TaskObj from 'model/taskObj';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { faMinimize, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import apiService from 'service/apiService';
import localStorageService from 'service/localStorageService';

export default function Taskbar() {
    const [desktopControll] = useContext(desktopAppTaskContex);
    const [appListIsOpen] = useState(false);

    const logout = async () => {
        if (!window.confirm('Log out of this session?')) {
            return;
        }
        try {
            await apiService.logout();
        } catch {
            /* still clear local session */
        }
        localStorageService.clearTokens();
        window.location.href = '/gate';
    };

    const groupedTaskListArr = useMemo(() => {
        const groupedTask: TaskObj[][] = [];
        desktopControll.taskList.forEach((task: TaskObj) => {
            const appID = task.app.config.appID;
            const groupIndex = groupedTask.findIndex((group) => group[0]?.app.config.appID === appID);
            if (groupIndex !== -1) {
                groupedTask[groupIndex].push(task);
            } else {
                groupedTask.push([task]);
            }
        });
        return groupedTask;
    }, [desktopControll.taskList]);

    const clickTask = (task: TaskObj) => {
        if (task.state === "unfocus") {
            desktopControll.focusTask(task.taskID);
        } else if (task.state === 'focus') {
            desktopControll.spotlightTask(null);
            desktopControll.minisizedTask(task.taskID);
        } else {
            desktopControll.focusTask(task.taskID);
        }
    };

    return (
        <div className="navbar">
            <div className="logoHead">
            <button className="dropbtn" onClick={() => desktopControll.launchFileBrowser()}>
                <img src={`${process.env.PUBLIC_URL}/w-argonDS.png`} alt="Argon" />
            </button>
            </div>
            {
                false && appListIsOpen &&
                <div id={'AppList'} className={'open'}>
                    {
                        desktopControll.appList.map((item: AppObj) =>
                            <div key={item.config.appID} className='appListItem' onMouseDown={() => { desktopControll.openingTask(item.config.appID); }}>
                                <img src={item.config.icon} alt="" />
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                    <span>{item.config.showName}</span>
                                </div>
                            </div>
                        )
                    }
                </div>
            }
            <div>
                {
                    <div className='taskBar' style={{ marginLeft: 5, height: '100%', display: "flex" }}>
                        {
                            groupedTaskListArr && groupedTaskListArr.map(
                                (taskGp: TaskObj[]) =>
                                    <div onMouseLeave={() => {/*setCurrentPreview(null);*/desktopControll.spotlightTask(null) }} key={taskGp[0].app.config.appID} className='taskHead' style={{ height: '100%' }} >
                                        <div
                                            className={'imageWrap' + (taskGp.find(t => t.state === "focus") ? ' hasFocus' : ' noFocus')}
                                            style={{ height: '100%' }}
                                            onClick={() => { if (taskGp.length === 1) clickTask(taskGp[0]); }}
                                        >
                                            <img src={taskGp[0].app.config.icon} style={{ height: '100%' }} alt="" />
                                        </div>
                                        {
                                            //taskGp.length > 1 &&
                                            <div className='taskNode'>
                                                <div className={'taskListItemBox'}>
                                                    {
                                                        taskGp.map(
                                                            (task: TaskObj) =>
                                                                <div key={task.taskID} className={'taskListItemItem' + (task.state === "focus" ? ' focus' : task.state === "minimized" ? ' docked' : '')} onMouseEnter={() => {/*if(task.state === 3 ){getScreenShot(task);}else{setCurrentPreview(null)} */ desktopControll.spotlightTask(task.taskID);}} onClick={() => clickTask(task)}>
                                                                    <div className='nodeWrap'>
                                                                        <div className={'node '}></div>
                                                                    </div>
                                                                    <div className='taskNamaAndTitle'>
                                                                        <span>{task.app.config.showName}{task.taskTitle && ' : ' + task.taskTitle}</span>
                                                                    </div>
                                                                    <FontAwesomeIcon className='closeBtn' style={{ display: 'none', width: 22, paddingTop: 3, color: 'white' }} size="lg" icon={faTimesCircle} onClick={() => { desktopControll.killTask(task.taskID) }} />
                                                                </div>
                                                        )
                                                    }
                                                </div>

                                            </div>
                                        }
                                    </div>
                            )
                        }
                    </div>
                }
            </div>
            <div className="rightTray">
                <button className="dropbtn" title="Logout" onClick={() => { void logout(); }}>
                    <FontAwesomeIcon className="fa" icon={faRightFromBracket} />
                </button>
                <button className="dropbtn" onClick={() => { desktopControll.minisizedTask("*") }} onMouseEnter={()=>{/* do it later when the file broswer done; */}}>
                    <FontAwesomeIcon className="fa" icon={faMinimize} />
                </button>
            </div>
        </div>
    )
}
